
document.addEventListener("DOMContentLoaded", () => {

    const script = document.getElementById("variant-dynamic-content");

    if (!script) return;

    const variantData = JSON.parse(script.textContent);

    function updateVariantContent(variantId) {

        const data = variantData[String(variantId)];

        if (!data) return;

        document.querySelectorAll("[data-variant-field]").forEach(el => {

            const field = el.dataset.variantField;

            if (data[field] !== undefined) {
                el.innerHTML = data[field] || "";
            }

        });

    }

    const variantInput = document.querySelector('form[action="/cart/add"] input[name="id"]');

    if (!variantInput) return;

    let currentVariant = variantInput.value;

    updateVariantContent(currentVariant);

    /*const observer = new MutationObserver(() => {

        if (variantInput.value !== currentVariant) {

            currentVariant = variantInput.value;

            updateVariantContent(currentVariant);

        }

    });

    observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
    });

    variantInput.addEventListener('change', () => {

        currentVariant = variantInput.value;

        updateVariantContent(currentVariant);

    });*/

});





// 58clicks 
/*document.addEventListener("DOMContentLoaded", () => {
  const product = window.ShopifyAnalytics?.meta?.product;
  const variantInput = document.querySelector('input[name="id"]');
  const button = document.querySelector(".product-form__submit");

  if (!product || !variantInput || !button) return;

  function updateButton() {
    const variant = product.variants.find(
      v => v.id === Number(variantInput.value)
    );

    if (!variant) return;

    const price = (variant.price / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD"
    });

    const label = button.querySelector("span");
    if (!label) return;

    // Avoid writing the same HTML over and over again
    const html = `ADD TO CART <span class="add-to-cart-price"> · ${price}</span>`;
    if (label.innerHTML !== html) {
      label.innerHTML = html;
    }
  }

  // First load
  updateButton();

  // Every time the theme modifies the button
  /*const observer = new MutationObserver(() => {

    observer.disconnect();

    updateButton();

    observer.observe(button, {
        childList: true,
        subtree: true
    });

  });

  observer.observe(button, {
    childList: true,
    subtree: true
  });*//*

});*/

